module.exports = __webpack_public_path__ + "static/media/Watermelon Dude.ac8added.jpg";